<template>
    <div class="slidewrap">
        <div class="slideval min">{{ min }}</div>
        <div class="slideval label">{{ label }}: {{ display }}</div>
        <div class="slideval max">{{ ( max > 0 ? '+' : '' ) + max }}</div>
        <div class="slidecontainer">
            <input type="range" :min :max :value="display" class="slider" :id @change="handleValue">
        </div>
    </div>

</template>
<script>
export default {
    name : "Heating",
    props: {
        id   : { type: String, required: false, default: '' + Date.now() },
        label: { type: String, required: true },
        value: { type: Number, required: true },
        min  : { type: Number, required: true },
        max  : { type: Number, required: true }
    },
    data()
    {
        return {
            display: ''
        }
    },
    emits: [ 'update' ],
    created()
    {
        this.display = this.$props.value
    },
    methods: {
        handleValue( event )
        {
            this.display = parseInt( event.target.value ) || 0
            this.$emit( 'update', this.display )
        }
    }
}
</script>